// extracted by mini-css-extract-plugin
export default {"container":"SearchFacet-module__container--g8Tbl","isSelected":"SearchFacet-module__isSelected--p0FgN"};